import WAboutCompareFirstMobile from './WAboutCompareFirstMobile'

export default WAboutCompareFirstMobile
